if ( window.wp && window.wp.ajax ) {

    const { registerBlockType, createBlock } = window.wp.blocks;
    const { InspectorControls, RichText, InnerBlocks } = window.wp.editor;
    const { PanelBody, CheckboxControl } = window.wp.components;

    registerBlockType('custom-gutenberg/tour-text', {
        title: 'Tour Text',
        description: 'Tour description with optional highlights.',
        icon: 'text',
        category: 'custom-content',
        example: {},

        attributes: {
            showHighlights: { type: 'boolean', default: true },
            highlightsLabel: { type: 'string', default: 'Izdvojeno' },
            highlights: { type: 'string', default: '' },
            title: { type: 'string', default: '' }
        },

        edit({ attributes, setAttributes }) {
            const { showHighlights, highlightsLabel, highlights, title } = attributes;

            return ([
                <InspectorControls key="settings">
                    <PanelBody title="Settings">
                        <CheckboxControl label="Show highlights" checked={ showHighlights } onChange={ showHighlights => setAttributes({ showHighlights: showHighlights }) } />
                    </PanelBody>
                </InspectorControls>,
                <div key="preview" className="tour-content">
                    { showHighlights && (
                        <div className="tour-detail-highlight">
                            <RichText tagName="span" className="eyebrow text-muted" value={ highlightsLabel } placeholder="Izdvojeno" onChange={ highlightsLabel => setAttributes({ highlightsLabel: highlightsLabel }) } />
                            <RichText tagName="div" className="highlight-text" value={ highlights } placeholder="Izdvojene lokacije i doživljaji" onChange={ highlights => setAttributes({ highlights: highlights }) } />
                        </div>
                    ) }
                    <div className="tour-description">
                        <RichText tagName="h2" className="mb-4" value={ title } placeholder="Tura" onChange={ title => setAttributes({ title: title }) } />
                        <InnerBlocks
                            template={ [['core/paragraph', { placeholder: 'Ovo je opis ture.' }]] }
                            templateLock={ false }
                            renderAppender={ InnerBlocks.ButtonBlockAppender }
                        />
                    </div>
                </div>
            ]);
        },

        save({ attributes }) {
            const { showHighlights, highlightsLabel, highlights, title } = attributes;

            return (
                <div className="tour-content">
                    { showHighlights && (
                        <div className="tour-detail-highlight">
                            <span className="eyebrow text-muted"><RichText.Content value={ highlightsLabel } /></span>
                            <RichText.Content tagName="div" className="highlight-text" value={ highlights } />
                        </div>
                    ) }
                    <div className="tour-description">
                        <RichText.Content tagName="h2" className="mb-4" value={ title } />
                        <InnerBlocks.Content />
                    </div>
                </div>
            );
        },
        deprecated: [{
            attributes: {
                showHighlights: { type: 'boolean', default: true },
                highlightsLabel: { type: 'string', default: 'Izdvojeno' },
                highlights: { type: 'string', default: '' },
                title: { type: 'string', default: '' },
                description: { type: 'string', default: '' }
            },
            migrate(attributes, innerBlocks) {
                const { description, ...updated } = attributes;
                return [updated, description ? [createBlock('core/paragraph', { content: description }), ...innerBlocks] : innerBlocks];
            },
            save({ attributes }) {
                const { showHighlights, highlightsLabel, highlights, title, description } = attributes;
                return (
                    <div className="tour-content">
                        { showHighlights && (
                            <div className="tour-detail-highlight">
                                <span className="eyebrow text-muted"><RichText.Content value={ highlightsLabel } /></span>
                                <RichText.Content tagName="div" className="highlight-text" value={ highlights } />
                            </div>
                        ) }
                        <div className="tour-description">
                            <RichText.Content tagName="h2" className="mb-4" value={ title } />
                            <RichText.Content tagName="p" value={ description } />
                        </div>
                    </div>
                );
            }
        }]
    });
}
